import { Component, Input } from '@angular/core';

export type StepperStepStatus = 'done' | 'active' | 'pending';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent {
    @Input() steps: string[] = [];
    @Input() currentStep = 1;

    statusFor(stepNumber: number): StepperStepStatus {
        if (stepNumber < this.currentStep) {
            return 'done';
        }
        if (stepNumber === this.currentStep) {
            return 'active';
        }
        return 'pending';
    }
}
